import { type Feature, useFeatureState } from '@app/hooks/useFeatureState'

const useIsFeatureEnabled = (feature: Feature): boolean => {
	const featureState = useFeatureState(feature)

	return typeof featureState !== 'undefined' && [true, 'on', 'true'].includes(featureState)
}

export default useIsFeatureEnabled
